exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card-vertical{font-size:14px;width:180px;height:190px;box-shadow:0px 2px 3px rgba(23,23,37,.2) !important}.pointerDiv{cursor:pointer}a.link-button:hover{text-decoration:none}a.link-button button.link-btn-padding{padding:1px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/CardVertical/CardVertical.scss
// module id = 7495
// module chunks = 101